<template>
  <header class="header"
          ref="headerleads">

    <div class="filters">
      <leads-filter-database @input="setDatabaseIdFilter" />

      <button class="btn btn-extra-round btn-primary"
              @click="emitLoadData">{{$t('message.generics.message.fetchData')}}</button>

      <leads-external-marketing-automation-management-modal />

      <div class="search-wrapper">
        <app-search @input="search"
                    @enter="emitLoadData" />
      </div>
    </div>

    <leads-upload-modal :showing.sync="showingUploadModal"
                        @added="reloadList" />

    <i class="mdi mdi-file-upload-outline mr-4"
       v-tooltip.auto="$t('message.leads.message.importDataBase')"
       @click="openUploadModal"></i>

    <!-- <i class="mdi mdi-view-grid"
       :class="{active: view === 'GRID'}"
       v-tooltip.auto="$t('message.generics.message.gridView')"
       @click="view = 'GRID'"></i>

    <i class="mdi mdi-view-list"
       :class="{active: view === 'TABLE'}"
       v-tooltip.auto="$t('message.generics.message.tableView')"
       @click="view = 'TABLE'"></i> -->

  </header>
</template>

<script>
import LeadsUploadModal from "@/components/modules/leads/external/upload/modal/LeadsUploadModal";
import LeadsFilterDatabase from "@/components/modules/leads/filter/database/LeadsFilterDatabase";
import LeadsExternalMarketingAutomationManagementModal from "../marketing-automation/manage/modal/LeadsExternalMarketingAutomationManageModal.vue"
import EventBus from "@packages/event-bus";
import AppSearch from "@components/Search";

export default {
  components: {
    AppSearch,
    LeadsFilterDatabase,
    LeadsUploadModal,
    LeadsExternalMarketingAutomationManagementModal
  },

  data() {
    return {
      showingUploadModal: false,
    };
  },

  computed: {
    view: {
      get() {
        return this.$store.state.leads.view;
      },

      set(value) {
        this.$store.commit("LEADS_SET_VIEW", value);
      },
    },

    user() {
      return this.$store.state.users.user;
    },
  },

  mounted() {
    this.$store.commit("LEADS_RESET_FILTER");
    let width = this.$refs.headerleads.clientWidth;
    let colsPerPage = Math.floor(width / 360);
    this.$store.commit("LEADS_SET_COLS_PER_PAGE", colsPerPage);
  },

  methods: {
    openUploadModal() {
      this.showingUploadModal = true;
    },

    search(search) {
      this.$store.commit("LEADS_SET_EXTERNAL_FILTER", {
        key: "filter",
        value: search,
      });
    },

    emitLoadData() {
      EventBus.$emit("LOAD_DATA");
    },

    reloadList() {
      this.emitLoadData();
    },

    setDatabaseIdFilter(value) {
      this.$store.commit("LEADS_SET_EXTERNAL_FILTER", {
        key: "databaseId",
        value: value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.header {
  display: flex;
  align-items: center;
  justify-content:  flex-start;

  .filters {
    display: flex;
    align-items: center;
    gap: 30px;

    flex-grow: 1;

    .search-wrapper {
      max-width: 200px;
      margin-left: auto;
      margin-right: 30px;
    }
  }

  .mdi {
    font-size: 28px;
    color: $grey-6;
    cursor: pointer;

    &.active {
      color: $blue-primary;
    }

    &.mdi-view-grid {
      font-size: 22px;
    }
  }
}
</style>
